<template>
  <Layout>
    <template v-slot:title>Restauración de Contraseña</template>
    <div class="mt-20 mx-4">
      <BaseAlert
        v-if="passwordTokenStatus === 'password-changed'"
        class="alert-success mb-8"
      >
        Tu contraseña ha sido correctamente modificada. Ya puedes
        <strong
          ><router-link :to="{ name: 'Login' }"
            >iniciar sesión</router-link
          ></strong
        >
        nuevamente.
      </BaseAlert>

      <div v-else-if="passwordTokenStatus === 'not-received'">
        <p class="my-8">
          Por favor, introduce tu nueva contraseña:
        </p>
        <form
          class="max-w-sm mx-auto mt-16"
          novalidate
          @submit.prevent="sendData"
        >
          <BaseInputText
            ref="password"
            type="password"
            label="Contraseña"
            name="password"
            class="mb-4"
            :value="password"
            :v="$v.password"
            @input="updatePassword"
            @blur="$v.password.$touch()"
          />

          <BaseInputText
            type="password"
            label="Repite Contraseña"
            name="repeatPassword"
            class="mb-4"
            :value="repeatPassword"
            :v="$v.repeatPassword"
            @input="updateRepeatPassword"
            @blur="$v.repeatPassword.$touch()"
          />

          <LoadingButton class="mt-2" :loading="sendingData">
            Enviar
          </LoadingButton>
        </form>
      </div>

      <div
        v-else-if="passwordTokenStatus === 'invalid'"
        class="max-w-screen-md mx-auto"
      >
        <p>
          El enlace utilizado para restaurar la contraseña no es válido, ha
          caducado, o ya ha sido utilizado. Por favor, vuelve a solicitar
          nuevamente la restauración de la contraseña.
        </p>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import updateFieldMixin from '@/mixins/updateFieldMixin'
import Layout from '@/layouts/MainLayout'
import LoadingButton from '@/components/LoadingButton'

export default {
  components: { Layout, LoadingButton },
  mixins: [validationMixin, updateFieldMixin],

  computed: {
    ...mapState('forms', ['sendingData']),
    ...mapState('auth', [
      'password',
      'repeatPassword',
      'passwordMinLength',
      'showAlert',
      'passwordTokenStatus',
    ]),
  },

  mounted() {
    if (this.passwordTokenStatus === 'not-received') {
      this.$refs.password.$el.querySelector('input').focus()
    }

    const token = this.$route.query.token
    this.$store.dispatch('auth/checkResetPasswordToken', token)
  },

  methods: {
    updatePassword(e) {
      this.$store.commit('auth/showAlert', false)
      this.updateField(e, 'auth/updatePassword', 'password')
    },

    updateRepeatPassword(e) {
      this.$store.commit('auth/showAlert', false)
      this.updateField(e, 'auth/updateRepeatPassword', 'repeatPassword')
    },

    sendData() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const token = this.$route.query.token
        const payload = {
          token,
          password: this.password,
          repeat_password: this.repeatPassword,
        }
        this.$store.dispatch('auth/resetPassword', { token, payload })
        this.$v.$reset()
      }
    },
  },

  validations() {
    const passLength = this.passwordMinLength
    return {
      password: { required, minLength: minLength(passLength) },
      repeatPassword: { required, sameAsPassword: sameAs('password') },
    }
  },
}
</script>
